import VisualWorking from '../etc/VisualWorking/VisualWorking';
import useWorking from '../../application/bloc/useWorking';

const Working = () => {
  useWorking();
  return <VisualWorking />;
};

export default Working;
